import { selectAdminApiUrl } from 'util/selector/apiSelector';
import { selectErrorCode, selectIsAxiosError } from 'util/selector/axiosSelector';

import { redirectToLogin } from 'reduxStore/auth/utils';
import axios, { AxiosInstance } from 'axios';
import { createException, createUnknownException } from 'exception/createException';
import { StatusCodes } from 'http-status-codes';
import { logInterceptedError } from 'shared/hooks/useInitializeDataDogLogs';

const backendApiClient: AxiosInstance = axios.create({
  baseURL: selectAdminApiUrl(),
  withCredentials: true,
  // `headers` are custom headers to be sent
  headers: {
    'Accept-Language': 'en-GB',
    Accept: 'application/json',
  },
});

// Add request interceptor to set Content-Type header appropriately
backendApiClient.interceptors.request.use(
  (config) => {
    // If data is FormData, let axios set the Content-Type automatically (with boundary)
    // Otherwise, set it to application/json for regular requests
    if (!(config.data instanceof FormData)) {
      config.headers['Content-Type'] = 'application/json';
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// redirect to login page on 401 UNAUTHORIZED code
backendApiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const errorCode = selectErrorCode(error);

    logInterceptedError(error);

    if (!selectIsAxiosError(error)) {
      throw createUnknownException();
    }

    if (errorCode === StatusCodes.UNAUTHORIZED) {
      redirectToLogin();
    }

    throw createException(error);
  },
);

export { backendApiClient };
